export default __webpack_public_path__ + "static/media/EP06_ERYTHREE.e132be4a.mp3";